import {
  Toaster,
  UpdateProps,
  HighlightType,
  StepData,
  TaskData,
  Task,
  Step
} from '@/components/onboarding-toaster/store'

export type { UpdateProps, HighlightType, StepData, TaskData, Task, Step }

export type ToasterState = Partial<Toaster> & { loaded: boolean }

export const data: ToasterState = {
  loaded: false,
  enabled: false,
  hide_completed: false,
  stowaway: true,
  tasks: {}
}
